module.exports = __webpack_public_path__ + "img/login_form_bg.de33f825.jpg";